import { PaymentPlanStatus } from '@debbie/common/dist/economy/payment-plans/index.js';
import * as caseFilterStore from '@debbie/cortex/dist/insights/caseFilter.js';
import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Checkbox } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
const PaymentPlansGroup = (props) => {
    const { caseFilter } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(FilterGroup, { name: lang.caseFilter.paymentPlansGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.paymentPlansStatuses &&
                caseFilter.paymentPlansStatuses.length), header: lang.caseFilter.paymentPlanStatuses, onDeactivate: () => caseFilterStore.clearFilter('paymentPlansStatuses') },
            React.createElement(Select, { value: (caseFilter.paymentPlansStatuses || []).map((paymentPlanStatus) => ({
                    label: lang.paymentPlans[paymentPlanStatus],
                    value: paymentPlanStatus,
                })), isMulti: true, placeholder: lang.caseFilter.selectPaymentPlanStatus, classNamePrefix: "select", options: Object.entries(PaymentPlanStatus).map((entry) => ({
                    label: lang.paymentPlans[entry[1]],
                    value: entry[1],
                })), onChange: (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    caseFilterStore.updateFilter({
                        paymentPlansStatuses: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.isNotHavingTheAbovePaymentPlansStatuses ===
                'boolean', header: lang.caseFilter.paymentPlanIsNotHavingStatuses, onDeactivate: () => caseFilterStore.clearFilter('isNotHavingTheAbovePaymentPlansStatuses') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.isNotHavingTheAbovePaymentPlansStatuses, onChange: (e) => {
                    if (e.target.checked) {
                        caseFilterStore.updateFilter({
                            isNotHavingTheAbovePaymentPlansStatuses: true,
                        });
                        return;
                    }
                    caseFilterStore.clearFilter('isNotHavingTheAbovePaymentPlansStatuses');
                } }))));
};
export default PaymentPlansGroup;
//# sourceMappingURL=PaymentPlansGroup.js.map